/**
 * react-string-replace 的本地 shim，不依赖 lodash，避免 lodash-es alias 导致的 CJS/ESM 兼容问题
 */
function escapeRegExp(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function replaceString(str, match, fn) {
  if (str === '') return str;
  if (typeof str !== 'string') {
    throw new TypeError('First argument to react-string-replace#replaceString must be a string');
  }

  const re = match instanceof RegExp ? match : new RegExp('(' + escapeRegExp(match) + ')', 'gi');
  const result = str.split(re);

  let curCharStart = 0;
  for (let i = 1, length = result.length; i < length; i += 2) {
    const curCharLen = result[i].length;
    curCharStart += result[i - 1].length;
    result[i] = fn(result[i], i, curCharStart);
    curCharStart += curCharLen;
  }
  return result;
}

export default function reactStringReplace(source, match, fn) {
  if (!Array.isArray(source)) source = [source];
  return [].concat(...source.map(x => (typeof x === 'string' ? replaceString(x, match, fn) : x)));
}
